const validate = (values) => {
    const errors = {};
  
    if (!values.domainId) {
      errors.domainId = 'Please select domain';
    }
    if (values.domainName && !values.libraryId) {
      errors.libraryId  = 'Please select Library Name ';
    }
    if (values.programId && !values.MasterDomainId) {
      errors.MasterDomainId  = 'Please select Domain Name ';
    }
    if (values.targetName && !values.masterProgramId) {
      errors.masterProgramId  = 'Please select Program Name ';
    }
    if(values.programId && !values.moveDomainId){
      errors.moveDomainId  = 'Please select Domain Name ';
    }
    if(values.targetId && !values.moveProgramId){
      errors.moveProgramId = 'Please select Program Name ';
    }

    return errors;
  };
  export default validate;


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SkillAquisition/components/Domain/validate.js